import React from "react";
import { Link } from "react-router-dom";
import DocumentHead from "../components/common/DocumentHead";
import "./NotFound.css";

/**
 * Catch-all 404 page.
 *
 * @returns {JSX.Element}
 */
function NotFound() {
  return (
    <section className="not-found">
      <DocumentHead
        title="Strana nije pronađena — ITArchitecture"
        description="Tražena strana ne postoji."
      />

      <div className="shell not-found__inner">
        <p className="t-label u-sand not-found__code t-numeral">404</p>

        <h1 className="t-headline not-found__title">
          Ova strana ne postoji.
        </h1>

        <p className="t-body not-found__body">Veza je možda netačna.</p>

        <div className="not-found__actions">
          <Link className="action action--solid" to="/">
            <span>Početna</span>
          </Link>
          <Link className="action" to="/projekti">
            <span>Projekti</span>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default NotFound;
